import React from 'react'
import { Segment } from 'semantic-ui-react'
import { languageOption } from 'organisms/FeedbackFilterGroup/constants'
import styled from 'styled-components'

export default function TranslationReviewPage({ targetLanguage, invalidLanguage }) {
  const getLanguageName = (code) =>
    Object.keys(languageOption).find(
      (key) => languageOption[key].toLowerCase() === code.toLowerCase()
    )

  const validLanguage = targetLanguage.filter(
    (lang) => !invalidLanguage.find((item) => item.language === lang)
  )

  return (
    <>
      <Segment.Group>
        {/* Valid languages ready to update */}
        {validLanguage.length > 0 && (
          <Segment>
            <GridLayoutDiv>
              <i className="col-start-1 fas fa-check text-green " />
              <strong className="col-start-2 col-span-full">
                {validLanguage.length} language{validLanguage.length !== 1 ? 's are' : ' is'} ready
                to update
              </strong>
              <div className="flex flex-wrap col-start-2 mt-2 col-span-full">
                {validLanguage.map((lang, index) => (
                  <span className="mb-0" key={lang}>
                    {index > 0 && ', '}
                    {getLanguageName(lang) || `'${lang}'`}
                  </span>
                ))}
              </div>
            </GridLayoutDiv>
          </Segment>
        )}

        {/* Invalid languages with missing translations */}
        {invalidLanguage.length > 0 && (
          <Segment>
            <GridLayoutDiv>
              {/* Header */}
              <i className="col-start-1 far fa-exclamation-triangle text-orange" />
              <strong className="col-start-2 col-span-full">
                {invalidLanguage.length} language{invalidLanguage.length !== 1 ? 's are' : ' is'}{' '}
                missing translations and won't be updated
              </strong>
              <div className="col-start-2 mt-2 col-span-full">
                {/* Details */}
                {invalidLanguage.map((item) => (
                  <div key={item.language}>
                    <strong>{getLanguageName(item.language) || `'${item.language}'`}: </strong>
                    {item.error}
                  </div>
                ))}
              </div>
            </GridLayoutDiv>
            <Segment
              secondary
              content="Partial translations aren't supported. Only fully translated languages will be updated."
            />
          </Segment>
        )}
      </Segment.Group>
    </>
  )
}

export const GridLayoutDiv = styled.div`
  display: grid;
  grid-template-columns: 1.5rem auto;
  align-items: center;
`



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/LanguageImportModal/TranslationReviewPage.js